<template>
  <v-dialog v-model="isVisible" max-width="420">
    <v-card class="app-dialog">
      <div class="dialog-icon">
        <v-icon size="26" color="#64ffda">{{ icon }}</v-icon>
      </div>

      <h2 class="dialog-title">{{ title }}</h2>
      <p class="dialog-text">{{ message }}</p>

      <div class="dialog-actions">
        <button type="button" class="primary-btn" @click="close">OK</button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SimpleDialogMessage",
  props: {
    title: {
      type: String,
      default: "Dialog"
    },
    message: {
      type: String,
      default: "message"
    },
    icon: {
      type: String,
      default: "mdi-information-outline"
    }
  },
  data() {
    return {
      isVisible: false,
    }
  },
  methods: {
    close() {
      this.isVisible = false;
    },
    open() {
      this.isVisible = true;
    }
  }
}
</script>

<style scoped>
.app-dialog {
  border-radius: 16px !important;
  background: var(--duallo-card-gradient) !important;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5) !important;
  color: #fff;
  padding: 28px 24px 22px;
  text-align: center;
  user-select: none;
}

.dialog-icon {
  width: 52px;
  height: 52px;
  margin: 0 auto 14px;
  border-radius: 14px;
  background: rgba(100, 255, 218, 0.1);
  border: 1px solid rgba(100, 255, 218, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-title {
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0 0 6px;
  color: #ffffff;
}

.dialog-text {
  font-size: 0.92rem;
  color: #b0bec5;
  margin: 0 0 22px;
  line-height: 1.5;
}

.dialog-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.primary-btn {
  flex: 0 1 160px;
  padding: 10px 18px;
  border-radius: 10px;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  background: rgba(100, 255, 218, 0.12);
  border: 1px solid rgba(100, 255, 218, 0.4);
  color: var(--duallo-accent);
}

.primary-btn:hover {
  background: rgba(100, 255, 218, 0.22);
}
</style>
